export default "__VITE_ASSET__IPFJ7u5e__"